import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

import { acquireApiAuthToken, isEntraConfigured } from './auth/entraClient'

let apolloClientInstance = null

function resolveEndpoint() {
  if (window.config && window.config.graphqlEndpoint) {
    return window.config.graphqlEndpoint
  }

  if (process.env.REACT_APP_GRAPHQL_ENDPOINT) {
    return process.env.REACT_APP_GRAPHQL_ENDPOINT
  }

  return 'http://localhost:4000/graphql'
}

export function createApolloClient() {
  const uri = resolveEndpoint()
  const authLink = setContext(async (_, { headers }) => {
    const nextHeaders = { ...(headers || {}) }

    if (isEntraConfigured()) {
      const token = await acquireApiAuthToken({ interactive: false })
      if (token) {
        nextHeaders.Authorization = `Bearer ${token}`
      }
    }

    if (!nextHeaders.Authorization) {
      try {
        const rawUser = localStorage.getItem('platform-ui.local-auth-user')
        const persistedUser = rawUser ? JSON.parse(rawUser) : null
        if (persistedUser && persistedUser.apiKey) {
          nextHeaders['x-api-key'] = persistedUser.apiKey
          nextHeaders['Ocp-Apim-Subscription-Key'] = persistedUser.apiKey
        }
      } catch (error) {
        // Ignore local storage read errors and continue without auth header.
      }
    }

    return { headers: nextHeaders }
  })

  return new ApolloClient({
    link: ApolloLink.from([authLink, new HttpLink({ uri, credentials: 'include' })]),
    cache: new InMemoryCache(),
  })
}

export function setApolloClient(client) {
  apolloClientInstance = client
}

export function getApolloClient() {
  if (!apolloClientInstance) {
    apolloClientInstance = createApolloClient()
  }

  return apolloClientInstance
}

export default {
  createApolloClient,
  getApolloClient,
  setApolloClient,
}
